import { useMemo } from "react";
//font awesome library
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faUserMagnifyingGlass);

export const FAIcon = ({ value, ...props }) => {
  const [prefix, iconName] = useMemo(() => value?.split(" ") || "", [value]);

  return value && <FontAwesomeIcon icon={[prefix, iconName]} {...props} />;
};
